import { render, staticRenderFns } from "./PreguntaRang.vue?vue&type=template&id=1414a07f&"
import script from "./PreguntaRang.vue?vue&type=script&lang=js&"
export * from "./PreguntaRang.vue?vue&type=script&lang=js&"
import style0 from "./PreguntaRang.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports